import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { emphasize, styled } from "@mui/material/styles";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Chip from "@mui/material/Chip";
import HomeIcon from "@mui/icons-material/Home";
import AssignmentIcon from "@mui/icons-material/Assignment";
import Pagination from "@mui/material/Pagination";
import  { useState, useRef } from 'react';
import { PDFDocument } from 'pdf-lib';
import jsPDF from "jspdf";
import ARI from "../assets/invoice.pdf";
//import XML from "../../public/progfile.xml";
import XML from "../assets/spec.xml";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

function createData(orderId, name, calories, fat, carbs, protein) {
  return { orderId, name, calories, fat, carbs, protein };
}

const rows = [
  createData(
    "WO001",
    "Casement window",
    "4sqmt",
    600.0,
    "Saint - Gobain",
    "New Request"
  ),
  createData(
    "WO002",
    "Transom",
    "4sqmt",
    700.0,
    "Saint - Gobain",
    "New Request"
  ),
  createData(
    "WO003",
    "Window",
    "4sqmt",
    800.0,
    "Saint - Gobain",
    "Processing.."
  ),
  createData("WO004", "Skylight", "4sqmt", 1000.0, "Saint - Gobain", "Shipped"),
  createData(
    "WO005",
    "Jalousie window",
    "4sqmt",
    400.0,
    "Saint - Gobain",
    "Processing.."
  ),
];
const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
}); // TypeScript only: need a type cast here because https://github.com/Microsoft/TypeScript/issues/26591

function handleClick(event) {
  event.preventDefault();
  console.info("You clicked a breadcrumb.");
}

function Workorders() {

  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  // Function to handle file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  // Function to trigger file input when "Upload" button is clicked
  const handleUploadButtonClick = () => {
    fileInputRef.current.click();
  };

  const testForPdf = () => {
    let getpdf = new jsPDF('p', 'px', 'a4');
    // getpdf.addImage(ARI, 'PNG', 65, 20, 500, 400)
    // getpdf.path("../assets/invoice.pdf")
    // getpdf.html
    // getpdf.getPageInfo
    // getpdf.getCurrentPageInfo
    // getpdf.addPage
    // getpdf.text(60, 60, assets/invoice.pdf)
    //  getpdf.save("assets/invoice.pdf")

    //  Fetch the text file content
    fetch(ARI)
    .then((response) => response.text())
    .then((text) => {
      // Add the fetched text content to the PDF
      getpdf.text(text, 10, 10);

      // Save or export the PDF
      getpdf.save('textfile.pdf');
    })
    .catch((error) => {
      console.error('Error fetching or adding text:', error);
    });

  };

  const handleDownload = () => {
    debugger
    if (selectedFile) {
      // Create a Blob object from the file content
      const fileBlob = new Blob([selectedFile], { type: selectedFile.type });
 
      // Create a temporary URL for the Blob object
      const fileUrl = URL.createObjectURL(fileBlob);
 
      // Create an anchor element to trigger the download
      const downloadLink = document.createElement('a');
      downloadLink.href = fileUrl;
      downloadLink.download = selectedFile.name;
 
      // Trigger a click event to initiate the download
      downloadLink.click();
 
      // Clean up by revoking the URL object to release resources
      URL.revokeObjectURL(fileUrl);
 
      console.log('File download initiated:', selectedFile.name);
    }
  };
 
  const openXML = () => {
    // const downloadLink = document.createElement('a');
    //   downloadLink.href = XML;
    //   downloadLink.target = '_blank';
    //   downloadLink.click();

    const xmlFilePath = XML;

    window.open(xmlFilePath);

    // const xmlFileName = XML;

    // Construct the URL to the XML file in the public folder.
    // const xmlFilePath = process.env.PUBLIC_URL + XML;

    // // Open the XML file in a new window or tab.
    // window.open(xmlFilePath);

    // if (XML) {
    //   // Create a Blob object from the file content
    //   const fileBlob = new Blob([XML], { type: "text/xml"});
 
    //   // Create a temporary URL for the Blob object
    //   const fileUrl = URL.createObjectURL(fileBlob);
    //   const xmlFilePath = process.env.PUBLIC_URL + 'fileUrl';
       
    //   window.open(xmlFilePath)
    // }


  }

  const openPDF = () => {
    const downloadLink = document.createElement('a');
      downloadLink.href = ARI;
      downloadLink.target = '_blank';
      downloadLink.click();
  }
 

  return (
    <div style={{ marginLeft: "7%", width: "90%" }}>
      <Paper
        variant="outlined"
        square
        style={{ marginTop: "3%", height: "10vh", padding: "10px" }}
      >
        <div
          style={{
            marginTop: "1%",
            float: "left",
            fontWeight: "bold",
            color: "#254A9A",
          }}
        >
          Work Ordes
        </div>
        <div
          role="presentation"
          style={{ marginTop: ".5%", float: "right" }}
          onClick={handleClick}
        >
          <Breadcrumbs aria-label="breadcrumb">
            <StyledBreadcrumb
              component="a"
              label="Home"
              href="#"
              icon={<HomeIcon fontSize="small" />}
            />
            {/* <StyledBreadcrumb component="a" href="#" label="Catalog" /> */}
            <StyledBreadcrumb
              label="Work Orders"
              component="a"
              href="#"
              icon={<AssignmentIcon fontSize="small" />}
            />
          </Breadcrumbs>
        </div>
      </Paper>
      <TableContainer style={{ marginTop: "2%" }} component={Paper}>

        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell
                align="center"
                style={{ backgroundColor: "#254A9A" }}
              >
                Order Code
              </StyledTableCell>
              <StyledTableCell
                style={{ backgroundColor: "#254A9A" }}
                align="center"
              >
                Item(s)
              </StyledTableCell>
              <StyledTableCell
                style={{ backgroundColor: "#254A9A" }}
                align="center"
              >
                Area
              </StyledTableCell>
              <StyledTableCell
                style={{ backgroundColor: "#254A9A" }}
                align="center"
              >
                Value
              </StyledTableCell>
              <StyledTableCell
                style={{ backgroundColor: "#254A9A" }}
                align="center"
              >
                Supplier
              </StyledTableCell>
              <StyledTableCell
                style={{ backgroundColor: "#254A9A" }}
                align="center"
              >
                Status
              </StyledTableCell>
              <StyledTableCell
                style={{ backgroundColor: "#254A9A" }}
                align="center"
              >
                Actions
              </StyledTableCell>{" "}
              {/* Added Actions column */}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
             
              <StyledTableRow key={row.orderId}>
                <StyledTableCell component="th" scope="row">
                  {row.orderId}
                </StyledTableCell>
                <StyledTableCell align="center">{row.name}</StyledTableCell>
                <StyledTableCell align="center">{row.calories}</StyledTableCell>
                <StyledTableCell align="center">{row.fat}</StyledTableCell>
                <StyledTableCell align="center">{row.carbs}</StyledTableCell>
                <StyledTableCell align="center">{row.protein}</StyledTableCell>
                <StyledTableCell align="center">
              <div>
      <input
        type="file"
        style={{ display: 'none' }}
        accept=".xml"
        ref={fileInputRef}
        onChange={handleFileChange}
      />
      <div style={{ alignItems: 'center' }}>
  {selectedFile ? (
    <div>
    <label>
        <button onClick={handleUploadButtonClick}>Update</button>
      </label>
      <label>
        <button onClick={handleDownload}>Download</button>
      </label> 
      {/* <label>
        <button onClick={testForPdf}>Download</button>
      </label>  */}
   
    </div>
  ) : (
    <label>
      {/* <button onClick={handleUploadButtonClick}>Upload</button> */}
     
      <Button variant="contained" color="primary" onClick={openXML}>View Spec
     
      </Button> &nbsp;&nbsp; 
      <Button variant="contained" color="secondary" onClick={openPDF}>
      Generate BOQ
      </Button>
    </label>
     
  )}
  {/* {selectedFile && <p>Selected file: {selectedFile.name}</p>} */}
</div>


    </div>
                </StyledTableCell>{" "}
                {/* Added View and Delete buttons */}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination count={10} color="primary" />
    </div>
  );
}
export default Workorders;